import { Box as MuiBox, styled, Skeleton } from "@mui/material";

import { Typography } from "components/Typography";

const Box = styled(MuiBox)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const Details = ({ data }) => {
  if (!data) {
    return <Skeleton height={120} />;
  }

  return (
    <Box>
      <Typography variant="dashboardHeading">
        {String(data.party || "Transaction Details").toUpperCase()}
      </Typography>
    </Box>
  );
};
